import { localized } from "@blocks/utils";
import { addFilter } from "@wordpress/hooks";

const disableBlocks = () => {
	addFilter(
		"magazine-blocks.block.metadata",
		"magazine-blocks/disable-blocks",
		(metadata) => {
			const name = metadata.name.split("/")[1];
			const enabled = localized.configs.blocks[name];
			if (!enabled) {
				if (typeof metadata.supports === "undefined") {
					metadata.supports = {};
				}
				metadata.supports.inserter = false;
			}
			return metadata;
		}
	);
};

export default disableBlocks;
